<template>
  <b-modal id="chat" size="xl" hide-footer>
    <b-card no-body style="border: 1px solid #ebe9f1">
      <div id="app">
        <section class="section">
          <div class="container">
            <!-- <div class="columns janela-principal"> -->

            <!-- Coluna Esquerda -->
            <b-row>
              <b-col class="m-0 p-0" md="4">
                <div class="column is-3 lista-de-conversas">
                  <b-row class="barra-superior-esquerda">
                    <div class="d-flex align-items-center w-100 px-1">
                      <b-input-group class="input-group-merge w-100">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="SearchIcon" class="text-muted" />
                        </b-input-group-prepend>
                        <b-form-input :placeholder=" $t('Adicionar_Servico_Num_OS_ou_Paciente')" id="buscarOS" type="text" v-model="campoBuscar" debounce="800" @update="buscar"/>
                      </b-input-group>
                    </div>
                  </b-row>
                  <b-row style="border-bottom: 1px solid rgb(235, 233, 241);" class="px-1">
                    <b-col cols="12">
                      <b-form-group class="mt-1">
                        <label for="buscarOs">{{ $t('Filtrar_Conversas_Laboratorio') }}</label>
                        <v-select
                            v-model="laboratorioId"
                            :options="listaLaboratorios"
                            :reduce="laboratorio => laboratorio.id"
                            label="nome"
                        >
                          <div slot="no-options">{{ $t('Laboratorio_nao_encontrado') }}</div>
                        </v-select>

                      </b-form-group>
                    </b-col>
                  </b-row>
                  <div class="lista">
                    <item-lista
                        style="height: 67px; border-bottom: 1px solid rgb(235, 233, 241);"
                        v-for="(conversa, indice) in conversasFiltradas"
                        :key="indice"
                        :mensagemAtiva="conversa.os_item_id === selecionado"
                        :nomeDoUsuario="conversa.servico_nome"
                        :avatar="conversa.num_os.toString()"
                        :laboratorio="conversa.laboratorio"
                        :novaMensagem="conversa.nova_mensagem"
                        :ultimaMensagem="conversa.paciente ? conversa.paciente : ''"
                        @click.native="buscaMensagensSelecionada(conversa), indiceAtivo = indice"
                    />
                  </div>
                </div>
              </b-col>

              <!-- Coluna Direita -->
              <b-col class="m-0 p-0" md="8">
                <div class="column conversa-ativa">
                  <!-- 1. Barra Superior -->
                  <div class="barra-superior-direita pl-2">
                    <h6 class="pt-2" v-if="nomeServicoSelecionado">{{ nomeServicoSelecionado }}</h6>
                  </div>
                  <!-- 2. Mensagens -->
                  <div class="lista-mensagens" id="view-scroll" ref="messages">
                    <mensagem
                        class="item"
                        :id="mensagem.id"
                        :conteudo="mensagem.mensagem"
                        :horario="mensagem.data | filtroData($i18n.locale)"
                        :verde="!mensagem.para_docs" 
                        @deletar="confirmarExclusao"
                        v-for="(mensagem, indice_) in mensagens"
                        :key="indice_"
                    />
                  </div>
                  <!-- 3. Barra Inferior -->
                  <div class="barra-inferior" v-if="selecionado > 0">
                    <b-row class="align-items-center">
                      
                      <!-- VISÃO 1: CHAT NORMAL -->
                      <template v-if="!isRecording">
                        
                        <!-- Botão de Anexo -->
                        <b-col cols="auto" class="pr-1">
                          <b-button variant="link" class="p-0 text-secondary" @click="$refs.inputArquivo.click()" title="Anexar arquivo">
                            <feather-icon icon="PaperclipIcon" size="22" />
                          </b-button>
                          <input type="file" ref="inputArquivo" class="d-none" multiple accept="image/*, audio/*, .mp3, .wav, .ogg, .mpeg, .m4a, .aac, .pdf, .mov, .mp4, .avi, .flv, .mkv, .webm, .mpg, .mpeg4, .stl, .dicom, .dcm, .zip, .ply, .rar" @change="prepararAnexos" />
                        </b-col>
                        
                        <!-- Input de Texto -->
                        <b-col class="px-0">
                          <b-form-input v-on:keyup.enter="enviarMensagem" :placeholder="$t('Mensagem')" v-model="conteudoASerEnviado" maxlength="255" />
                        </b-col>

                        <!-- Botões de Ação (Microfone ou Enviar) -->
                        <b-col cols="auto" class="pl-2">
                          
                          <!-- Microfone (Se input vazio) -->
                          <b-button v-if="!conteudoASerEnviado" variant="link" class="p-0 text-primary" @click="iniciarGravacao" title="Gravar Áudio">
                            <feather-icon icon="MicIcon" size="22" />
                          </b-button>
                          
                          <!-- Enviar (Se tiver texto) -->
                          <b-button v-else variant="link" class="p-0 text-primary" @click="enviarMensagem" title="Enviar Mensagem">
                            <feather-icon icon="SendIcon" size="22" />
                          </b-button>

                        </b-col>
                      </template>

                      <!-- VISÃO 2: GRAVANDO ÁUDIO -->
                      <template v-else>
                        <b-col class="px-2 d-flex align-items-center justify-content-between w-100">

                          <!-- Esquerda: ponto + tempo + ondas -->
                          <div class="d-flex align-items-center">
                            <div class="recording-dot mr-2"></div>

                            <span class="recording-time mr-3">{{ tempoFormatado }}</span>

                            <!-- Ondas animadas (estilo WhatsApp) -->
                            <div class="waveform">
                              <div class="bar"></div>
                              <div class="bar"></div>
                              <div class="bar"></div>
                              <div class="bar"></div>
                              <div class="bar"></div>
                              <div class="bar"></div>
                              <div class="bar"></div>
                              <div class="bar"></div>
                              <div class="bar"></div>
                              <div class="bar"></div>
                            </div>
                          </div>

                          <!-- Direita: botões -->
                          <div class="d-flex align-items-center">
                            <b-button
                              variant="link"
                              class="p-0 text-secondary mr-3"
                              @click="cancelarGravacao"
                              title="Cancelar"
                            >
                              <feather-icon icon="TrashIcon" size="22" />
                            </b-button>

                            <b-button
                              variant="link"
                              class="p-0 text-success"
                              @click="pararEEnviarGravacao"
                              title="Enviar Áudio"
                            >
                              <feather-icon icon="SendIcon" size="22" />
                            </b-button>
                          </div>
                        </b-col>
                      </template>
                      
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>

            <!-- </div> -->
          </div>
        </section>
      </div>
    </b-card>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BForm,
  BFormInput,
  BInputGroup,
  BFormGroup,
  BInputGroupPrepend,
  BAvatar,
  BButton,
  BImg,
} from "bootstrap-vue";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ItemLista from "./ItemDaListaDeConversa.vue";
import Mensagem from "./MensagemDaConversaAtiva.vue";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import vSelect from "vue-select";
import axios from "axios";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BForm,
    BFormInput,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BAvatar,
    BButton,
    BImg,
    ItemLista,
    Mensagem,
    VuePerfectScrollbar,
    vSelect,
  },
  name: "App",
  data: function () {
    return {
      //conversas: conversasIniciais,
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      },
      campoBuscar: '',
      indiceAtivo: 0,
      conteudoASerEnviado: "",
      laboratorioId: 0,

      isRecording: false,
      mediaRecorder: null,
      audioChunks: [],
      tempoGravacao: 0,
      intervaloTempo: null,
    }
  },

  computed: {
    ...mapState({
      conversas: state => state.chat.listaServicosChat,
      selecionado: state => state.chat.selecionado,
      laboratorios: state => state.laboratorios.laboSelecionado,
      listaLaboratorios: state => state.laboratorios.laboratorios,
      mensagens: state => state.chat.mensagens,
      arraySelecionado: state => state.chat.arraySelecionado,
      user: state => state.user.user
    }),
    ...mapGetters("chat",["nomeServicoSelecionado", "listaFiltros"]),

    conversasFiltradas() {

      if(this.laboratorioId > 0) {
        return this.listaFiltros.filter( v => Number(v.id_company) === Number(this.laboratorioId))
      }
      return this.listaFiltros

    },

    tempoFormatado() {
      const minutos = Math.floor(this.tempoGravacao / 60).toString().padStart(2, '0');
      const segundos = (this.tempoGravacao % 60).toString().padStart(2, '0');
      return `${minutos}:${segundos}`;
    }

  },

  watch: {
    mensagens() {
      this.ajustaScroll()
    },
  },

  methods: {
    buscar() {
      let buscar = !isNaN(this.campoBuscar) ? 'num_os='+ this.campoBuscar : 'paciente='+this.campoBuscar.toLowerCase()

      if (!this.campoBuscar.length) {
        this.$store.commit('chat/STORE_LISTA_FILTRADA', [] )
        this.$store.commit('chat/STORE_CAMPO_BUSCAR', false )
      } else {
        this.$store.commit('chat/STORE_CAMPO_BUSCAR', true )
        this.$http.get("odontodocs/chat/buscar/" + this.laboratorios+'?'+buscar)
            .then((res) => {

              this.$store.commit('chat/STORE_LISTA_FILTRADA', res.data )

            })
            .catch((error) => {
              //   this.getErrors = this.$responseMessages.getMessage(error, null);
            })
            .finally(() => {
              //  this.submit = false;
            });
      }
    },
    ajustaScroll() {
      if (this.$refs.messages) {
        setTimeout( ()=> {
          this.$refs.messages.scrollTo(0, this.$refs.messages.scrollHeight)
        }, 50)
      }
    },
    adicionaNaLista(serv) {
      if(this.conversas.length) {
        let existeItem = this.conversas.find( v => v.os_item_id === serv.items_id)

        if(existeItem == undefined) {

          let item = {
            data_lancamento: moment(Date()).format('YYYY-MM-DD H:mm:ss'),
            nova_mensagem: true,
            id_company: this.laboratorios,
            num_os: serv.num_os,
            os_item_id: serv.items_id,
            paciente: serv.paciente,
            servico_nome: serv.servico_nome,
            tem_mensagem: true,
          }

          this.$store.commit('chat/ADD_LISTA_SERVICOS', item )

        }

      }
    },
    enviarMensagem() {
      if (this.conteudoASerEnviado) {

        let payload = {
          mensagem: {
            data: moment(Date()).format('YYYY-MM-DD H:mm:ss'),
            id_company: this.arraySelecionado.id_company,
            mensagem: this.conteudoASerEnviado,
            os_item_id: this.selecionado,
            para_labo: 1,
            para_docs: 0,
            nova_mensagem: true,
            tem_mensagem: true,
          },
          item: {
            ...this.arraySelecionado,
            data_lancamento: moment(Date()).format('YYYY-MM-DD H:mm:ss'),
            os_item_id: this.selecionado,
            nova_mensagem: true,
            tem_mensagem: true,
          }
        }
        this.$http.post('odontodocs/chat/'+this.arraySelecionado.id_company, payload).then( (res) => {
          payload.mensagem.id = res.data.mensagem.id;
          this.$store.commit('chat/ADD_MENSAGENS', payload)

          let arraySelecionado = {
            ...this.arraySelecionado,
            items_id: this.arraySelecionado.os_item_id
          }
          this.adicionaNaLista(arraySelecionado)
        })

        this.conteudoASerEnviado = ''

      }
    },

    async buscaMensagensSelecionada(serv) {
      this.$store.commit('chat/STORE_SELECIONADO', serv.os_item_id)
      this.$store.commit('chat/SETAR_LISTA_SEVICOS_LIDA', serv.os_item_id)
      this.$store.commit('chat/STORE_ARRAY_SELECIONADO', serv)

      let payload = {
        id_company: this.laboratorios,
        os_item_id: serv.os_item_id,
      }
      await this.$store.dispatch('chat/listaMensagens', payload)
    },

    async prepararAnexos(event) {
      const arquivos = event.target.files;
      if (!arquivos.length) return;

      const s3AxiosInstance = axios.create();

      for (let i = 0; i < arquivos.length; i++) {
        const arquivo = arquivos[i];

        const uniqueFileName = this.getUniqueFileName(arquivo);

        try {
          const presignedData = await this.$http.get(`odontodocs/pedidos/uploads/get_url?nome=${uniqueFileName.nome}`);
          const presignedUrl = presignedData.data;

          await s3AxiosInstance.put(presignedUrl, arquivo, {
            headers: {
              "Content-Type": arquivo.type
            }
          });

          let payloadImagem = {
            url: uniqueFileName.nome,
            nome: arquivo.name,
            tamanho: (arquivo.size / 1048576).toFixed(2), // Tamanho em MB
            tipo: this.getType(uniqueFileName.ext),
            os_ficha_id: this.selecionado
          };

          await this.$http.post(`odontodocs/chat/anexo/salvar/${this.laboratorios}`, payloadImagem);
          
          console.log('Upload concluído com sucesso!', payloadImagem);
          this.conteudoASerEnviado = `[ANEXO]${uniqueFileName.nome}|${arquivo.name}`;
          this.enviarMensagem();

        } catch (error) {
          console.error("Falha ao subir o arquivo:", arquivo.name, error);
        }
      }

      this.$refs.inputArquivo.value = '';
    },

    getUniqueFileName(file) {
      const parts = file.name.split('.');
      const rawExtension = parts.length > 1 ? parts.pop() : '';
      const rawFileName = parts.join('.') || 'arquivo';
      
      const removeDiacritics = (str) =>
        str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      
      const sanitize = (str) => {
        return removeDiacritics(str)
          .replace(/\s+/g, '_')
          .replace(/[+#%?&=<>:"'`~^|\\\/\[\]{}\(\),;@!$*]/g, '_')
          .replace(/[^A-Za-z0-9._-]/g, '_')
          .replace(/_+/g, '_')
          .replace(/^_+|_+$/g, '');
      };
      
      const extension = sanitize(rawExtension || '').toLowerCase();
      let fileName = sanitize(rawFileName);
      if (!fileName) fileName = 'arquivo';
      
      const randomString =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
      
      const safeBase = `${fileName}-${randomString}`;
      return {
        nome: extension ? `${safeBase}.${extension}` : safeBase,
        ext: extension
      };
    },
    
    getType(ext) {
      const imageExtensions = ['png', 'jpg', 'jpeg', 'bmp'];
      if(ext && imageExtensions.includes(ext)) {
        return 1;
      }
      return 2;
    },

    confirmarExclusao(idDaMensagem) {
      this.$bvModal.msgBoxConfirm(this.$t('Deseja_realmente_excluir_esta_mensagem_do_chat'), {
        title: this.$t('Confirmar_Exclusao'),
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('Sim_excluir'),
        cancelTitle: this.$t('Cancelar'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
      .then(confirmado => {
        if (confirmado) {
          this.$http.delete(`odontodocs/chat/${idDaMensagem}`)
            .then(() => {
              let payload = {
                id_company: this.laboratorios,
                os_item_id: this.selecionado,
              }
              this.$store.dispatch('chat/listaMensagens', payload);
            })
            .catch(err => {
              console.error("Erro ao excluir mensagem no OdontoDocs:", err);
            });
        }
      });
    },

    async iniciarGravacao() {
  // 1. Verifica se a API está disponível
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    this.$bvToast.toast(
      this.$t("O_navegador_bloqueou_o_microfone_O_sistema_precisa_ser_acessado_via_HTTPS"),
      {
        title: this.$t("Microfone_Bloqueado"),
        variant: "danger",
        solid: true,
        autoHideDelay: 6000
      }
    );
    return;
  }

  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

    this.isRecording = true;
    this.tempoGravacao = 0;
    this.audioChunks = [];

    this.mediaRecorder = new MediaRecorder(stream);

    this.mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        this.audioChunks.push(event.data);
      }
    };

    this.mediaRecorder.start();

    this.intervaloTempo = setInterval(() => {
      this.tempoGravacao++;
    }, 1000);

  } catch (error) {
    console.error("Erro ao acessar o microfone:", error);

    let mensagem = "Não foi possível acessar o microfone.";

    if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") {
      mensagem = "Permissão do microfone negada. Clique no ícone de cadeado na barra de endereço e permita o acesso ao microfone.";
    } else if (error.name === "NotFoundError" || error.name === "DevicesNotFoundError") {
      mensagem = "Nenhum microfone foi encontrado no dispositivo.";
    } else if (error.name === "NotReadableError" || error.name === "TrackStartError") {
      mensagem = "O microfone está sendo usado por outro aplicativo.";
    } else if (error.name === "OverconstrainedError") {
      mensagem = "Não foi possível satisfazer as restrições do microfone.";
    } else if (error.name === "SecurityError") {
      mensagem = "Acesso ao microfone bloqueado por questões de segurança (a página precisa estar em HTTPS).";
    }

    this.$bvToast.toast(mensagem, {
      title: "Erro de Microfone",
      variant: "danger",
      solid: true,
      autoHideDelay: 7000
    });
  }
},

    cancelarGravacao() {
      this.pararGravador(false);
    },

    pararEEnviarGravacao() {
      this.pararGravador(true);
    },

    pararGravador(enviar) {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.onstop = () => {
          if (enviar && this.audioChunks.length > 0) {
            this.processarEEnviarAudio();
          }
          this.limparEstadoGravacao();
        };
        this.mediaRecorder.stop();
      } else {
        this.limparEstadoGravacao();
      }
    },

    limparEstadoGravacao() {
      this.isRecording = false;
      clearInterval(this.intervaloTempo);
      this.tempoGravacao = 0;
      
      if (this.mediaRecorder && this.mediaRecorder.stream) {
        this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
      }
    },

    async processarEEnviarAudio() {
      const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
      
      // A correção foi feita aqui: tiramos o "this.$" e deixamos só "moment()"
      const audioFile = new File([audioBlob], `Audio_${moment().format('DD-MM-YYYY_HH-mm-ss')}.webm`, { type: 'audio/webm' });
      
      const eventoFalso = {
        target: { files: [audioFile] }
      };
      
      await this.prepararAnexos(eventoFalso);
    },

  },

  filters: {
    filtroData(data) {
      if(!data) return
      return moment(data).format('DD/MM/YYYY H:mm')
    }
  }
};
</script>

<style>
/* Barra Superior */
.barra-superior-esquerda {
  margin: 0;
  height: 60px;
  padding-top: 5px;
  background: white;
  border-bottom: 1px solid rgb(235, 233, 241);
}

.barra-superior-direita {
  margin: 0;
  height: 60px;
  background: white;
  border-left: 1px solid rgb(235, 233, 241);
  border-bottom: 1px solid rgb(235, 233, 241);
}

.lista {
  height: 440px;
  overflow-y: scroll;
}
/* Coluna Esquerda */
.lista-de-conversas {
  padding: 0;
  background: white;
}
/* Coluna Direita */
.conversa-ativa {
  padding: 0;
  background-color: #f0f2f7;
  position: relative;
}
.lista-mensagens {
  padding-bottom: 77px;
  height: 500px;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  background-size: 100px;
  background-image: url('./dentes.jpg');
}
.lista-mensagens .item:first-child {
  margin-top: auto;
}
/* Barra Inferior */
.barra-inferior {
  bottom: 0;
  width: 100%;
  padding: 15px;
  position: absolute;
  background: white;
  border-left: 1px solid rgb(235, 233, 241);
}

/* ===== GRAVAÇÃO ESTILO WHATSAPP ===== */
.recording-dot {
  width: 12px;
  height: 12px;
  background-color: #ef4444;
  border-radius: 50%;
  animation: pulse-dot 1.2s ease-in-out infinite;
}

@keyframes pulse-dot {
  0%   { transform: scale(1); opacity: 1; }
  50%  { transform: scale(1.3); opacity: 0.6; }
  100% { transform: scale(1); opacity: 1; }
}

.recording-time {
  font-weight: 600;
  font-size: 15px;
  color: #ef4444;
  min-width: 48px;
}

.waveform {
  display: flex;
  align-items: center;
  gap: 3px;
  height: 28px;
}

.waveform .bar {
  width: 3px;
  background-color: #ef4444;
  border-radius: 2px;
  animation: wave 1.1s ease-in-out infinite;
}

.waveform .bar:nth-child(1)  { height: 8px;  animation-delay: 0.0s; }
.waveform .bar:nth-child(2)  { height: 14px; animation-delay: 0.1s; }
.waveform .bar:nth-child(3)  { height: 20px; animation-delay: 0.2s; }
.waveform .bar:nth-child(4)  { height: 12px; animation-delay: 0.3s; }
.waveform .bar:nth-child(5)  { height: 24px; animation-delay: 0.4s; }
.waveform .bar:nth-child(6)  { height: 16px; animation-delay: 0.5s; }
.waveform .bar:nth-child(7)  { height: 10px; animation-delay: 0.6s; }
.waveform .bar:nth-child(8)  { height: 22px; animation-delay: 0.7s; }
.waveform .bar:nth-child(9)  { height: 14px; animation-delay: 0.8s; }
.waveform .bar:nth-child(10) { height: 18px; animation-delay: 0.9s; }

@keyframes wave {
  0%, 100% { transform: scaleY(0.4); opacity: 0.6; }
  50%      { transform: scaleY(1);   opacity: 1; }
}

</style>
